import { supabaseClient } from '../../config/supabase';
import AuthRecoveryDialog from './AuthRecoveryDialog';

export default function AuthRecoveryModal(props) {
    return <AuthRecoveryDialog {...props} client={supabaseClient} />;
}
